import * as Yup from 'yup'
import { EMPTY_STATE_OPTION } from 'components/StateSearch/constants'
import { PHONE_REGEX, ZIP_CODE_MAX_LENGTH } from 'constants/validationSchemas'

export const ADDRESS_FIELD_NAMES = {
  FULL_NAME: 'fullName',
  COMPANY: 'company',
  PHONE: 'phone',
  ADDRESS_LINE1: 'addressLine1',
  ADDRESS_LINE2: 'addressLine2',
  ZIP_CODE: 'zipCode',
  CITY: 'city',
  STATE: 'state',
  COUNTRY: 'country',
} as const

export const AddressValidationSchema = Yup.object().shape({
  [ADDRESS_FIELD_NAMES.FULL_NAME]: Yup.string()
    .trim()
    .label('Full name')
    .required(),
  [ADDRESS_FIELD_NAMES.COMPANY]: Yup.string()
    .trim()
    .label('Company')
    .nullable(),
  [ADDRESS_FIELD_NAMES.PHONE]: Yup.string()
    .label('Phone')
    .matches(PHONE_REGEX, 'Phone number is not valid')
    .required(),
  [ADDRESS_FIELD_NAMES.ADDRESS_LINE1]: Yup.string()
    .trim()
    .label('Address Line 1')
    .required(),
  [ADDRESS_FIELD_NAMES.ADDRESS_LINE2]: Yup.string()
    .trim()
    .label('Address Line 2')
    .nullable(),
  [ADDRESS_FIELD_NAMES.ZIP_CODE]: Yup.string()
    .trim()
    .max(
      ZIP_CODE_MAX_LENGTH,
      `Must be less than ${ZIP_CODE_MAX_LENGTH + 1} characters`
    )
    .label('Zip Code')
    .required(),
  [ADDRESS_FIELD_NAMES.CITY]: Yup.string().label('City').required(),
  [ADDRESS_FIELD_NAMES.STATE]: Yup.object().when(ADDRESS_FIELD_NAMES.COUNTRY, {
    is: ({ value }) => value?.isoCode === 'us',
    then: Yup.object().shape({
      value: Yup.object().shape({
        title: Yup.string().required('State is a required field').nullable(),
      }),
    }),
  }),
  [ADDRESS_FIELD_NAMES.COUNTRY]: Yup.object()
    .shape({
      value: Yup.object().shape({
        isoCode: Yup.string()
          .required('Country is a required field')
          .nullable(),
      }),
    })
    .required(),
})

export const ADDRESS_FIELDS_INITIAL_VALUES = {
  [ADDRESS_FIELD_NAMES.FULL_NAME]: '',
  [ADDRESS_FIELD_NAMES.COMPANY]: null,
  [ADDRESS_FIELD_NAMES.PHONE]: '',
  [ADDRESS_FIELD_NAMES.ADDRESS_LINE1]: '',
  [ADDRESS_FIELD_NAMES.ADDRESS_LINE2]: null,
  [ADDRESS_FIELD_NAMES.ZIP_CODE]: '',
  [ADDRESS_FIELD_NAMES.CITY]: '',
  [ADDRESS_FIELD_NAMES.STATE]: EMPTY_STATE_OPTION,
  [ADDRESS_FIELD_NAMES.COUNTRY]: {
    label: 'United States',
    value: {
      isoCode: 'us',
      title: 'United States',
    },
  },
}
